// removed by extract-text-webpack-plugin
module.exports = {"container":"_1UgySfN","carouselLink":"_3H8AuY1","label":"lFlpBn6","label__light":"_1ivrAR2","label__sale":"J4dMEZd","subtitle":"_1-ghia1"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/CarouselLink.css
// module id = ./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/CarouselLink.css
// module chunks = client.sitechrome